"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // File was autogenerated by tools/generateLabels.js script

var _default = {
  AccessDenied: "Brak dostępu",
  ValueRequired: "Wartość jest wymagana"
};
exports.default = _default;